module.exports = __webpack_public_path__ + "img/1.b6b70b72.jpg";